import ArticleInfoFooter from "./ArticleInfoFooter";
export default ArticleInfoFooter;